import languages from "./languages.json";

export const supportedLngs = Object.keys(languages);

export default languages;
